/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitTestingEntityRelationRequestBody
 */
export interface MonitTestingEntityRelationRequestBody {
    /**
     * 
     * @type {string}
     * @memberof MonitTestingEntityRelationRequestBody
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof MonitTestingEntityRelationRequestBody
     */
    config_item: string;
}

/**
 * Check if a given object implements the MonitTestingEntityRelationRequestBody interface.
 */
export function instanceOfMonitTestingEntityRelationRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "config_item" in value;

    return isInstance;
}

export function MonitTestingEntityRelationRequestBodyFromJSON(json: any): MonitTestingEntityRelationRequestBody {
    return MonitTestingEntityRelationRequestBodyFromJSONTyped(json, false);
}

export function MonitTestingEntityRelationRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitTestingEntityRelationRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': json['entity_id'],
        'config_item': json['config_item'],
    };
}

export function MonitTestingEntityRelationRequestBodyToJSON(value?: MonitTestingEntityRelationRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'config_item': value.config_item,
    };
}

